export default __webpack_public_path__ + "static/media/nicety.691cbbc5.png";